<template>
  <div
    class="tw-bg-white tw-p-40 tw-text-primary-grey-800 tw-w-full tw-flex tw-items-center tw-gap-4 tw-flex-col"
  >
    <img alt="site logo" class="tw-inline-flex tw-w-auto" :src="logo" />
    <h1
      class="tw-text-primary-grey-700 tw-text-xl tw-font-semibold tw-flex tw-items-center tw-gap-2"
    >
      {{ $t("email-archiving-title") }}
    </h1>
    <p>{{ $t("subtext-email-archiving") }}</p>
    <authorisation-wrapper
      :resource="EMAIL_ARCHIVING"
      :action="WRITE"
      v-slot="{ isAllowed: allowedWriteEmailArchiving }"
    >
      <cl-button
        variant="secondary"
        href="#"
        :data-test-id="`${tier}-email-archiving-external-link`"
        :readonly="!allowedWriteEmailArchiving"
        @click="openExternalLink"
      >
        <span class="tw-mr-2">{{ $t("open-email-archiving") }}</span>
        <cb-icon-external-link
          class="tw-mt-[-6px]"
          color="currentColor"
        ></cb-icon-external-link>
      </cl-button>
    </authorisation-wrapper>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from "vue";
import { usePageMetaStore } from "@/store/pageMeta.store";
import { useI18n } from "vue-i18n";
import { useGlobalOrganisationID } from "@/composables/useGlobalOrganisationID";
import { useIsMspRoute } from "@/composables/useIsMspRoute";
import { SERVICE_ICON } from "@/utils/services.ts";
import { useArcTitanStore } from "@/modules/ArcTitan/store/arcTitan.store";

import { AuthorisationWrapper, EMAIL_ARCHIVING, WRITE } from "@/authorisation";

const { t } = useI18n();

const pageMetaStore = usePageMetaStore();
const arcTitanStore = useArcTitanStore();

const logo = new URL(
  "@/assets/icons/general/arctitan_watermark.svg",
  import.meta.url,
).href;

const fetchExternalLink = async () => {
  const { mspGlobalOrganisationId, customerGlobalOrganisationId } =
    useGlobalOrganisationID();
  const { isMspRoute } = useIsMspRoute();

  const organisationID = isMspRoute.value
    ? mspGlobalOrganisationId
    : customerGlobalOrganisationId;

  try {
    await arcTitanStore.fetchArcTitanLoginUrl({
      organisationID: organisationID.value,
    });
  } catch {
    // Handled in axios interceptor
  }
};

const openExternalLink = () => {
  window.open(arcTitanStore.link ?? undefined, "_blank");
};

onMounted(() => {
  pageMetaStore.setPageTitle({
    title: t("email-archiving-label"),
    icon: t(SERVICE_ICON.ARC_SERVICE),
  });
  fetchExternalLink();
});
const { isMspRoute } = useIsMspRoute();
const tier = computed(() => (isMspRoute.value ? "msp" : "customer"));
</script>
